import { EventEmitter } from "../util/eventemitter";

export class GameOptions extends EventEmitter {
    options: any;

    constructor() {
        super();
        this.options = {
            musicVolumePercentage: 5,
            movementMode: "traditional",
        };
    }

    set(name: any, val: any) {
        this.options[name] = val;
        this.emit("changed", this);
    }

    get(name: any) {
        return this.options[name];
    }

}

/**
 * @constructor
 */





